<template>
  <v-container class="mt-2">
    <v-card
      class="px-2 pb-2">
      <v-row>
        <v-col>
          <p>Cobertura - Detalhar</p>
        </v-col>
        <v-col cols="3" class="d-flex flex-row justify-end">
          <v-btn class="mr-1" small @click="remove">
            <v-icon small title="Remover">fas fa-trash</v-icon>
          </v-btn>
          <v-btn class="mr-1" small @click="edit">
            <v-icon small title="Editar">fas fa-edit</v-icon>
          </v-btn>
          <v-btn small @click="goBack">
            <v-icon small title="Voltar">fas fa-arrow-circle-left</v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <v-divider class="mb-4"></v-divider>

      <v-skeleton-loader v-if="!coverage" type="article, actions" />

      <v-row v-if="coverage">
        <v-col cols="4">
          <strong>Nome: </strong>
          {{ coverage.name }}
        </v-col>
        <v-col cols="4">
          <strong>Tipo do Registro: </strong>
          {{ coverage.recordType }}
        </v-col>
        <v-col cols="4">
          <strong>Regra: </strong>
          {{ coverage.rule }}
        </v-col>
        <v-col cols="4">
          <strong>Cobertura ANS: </strong>
          {{ coverage.ansCoverage === false ? 'Não' : 'Sim' }}
        </v-col>
        <v-col cols="4">
          <strong>Diferencial Executivo: </strong>
          {{ coverage.executiveDifferential === false ? 'Não' : 'Sim' }}
        </v-col>
        <v-col cols="4">
          <strong>Grupo de Cobertura: </strong>
          {{ coverage.groupName }}
        </v-col>
      </v-row>

      <v-divider class="mt-2 mb-2"></v-divider>

      <v-container fluid>
        <v-row justify="center">
          <v-expansion-panels accordion>
            <v-expansion-panel @click="toggleCarriersActions">
              <v-expansion-panel-header>
                <v-row class="mr-2">
                  <v-col cols="9">Operadoras</v-col>
                  <v-col
                    cols="3"
                    class="d-flex justify-end"
                    v-if="showCarriersActions"
                  >
                    <v-btn class="mr-1" small @click.native.stop="$refs.carrierSearch.show">
                      <v-icon small title="Adicionar">fas fa-plus</v-icon>
                    </v-btn>
                    <v-btn small @click.native.stop="$refs.carriers.removeAll">
                      <v-icon small title="Remover">fas fa-trash</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                
                <coverage-carrier ref="carriers" :coverage-id="id" />
              
              </v-expansion-panel-content>
            </v-expansion-panel>
            
            <carrier-search ref="carrierSearch" :coverage-id="id" @selected="addAccount" />
          
          </v-expansion-panels>
          <v-expansion-panels>
            <v-expansion-panel @click="togglePlansActions">
              <v-expansion-panel-header>
                <v-row  class="mr-2">
                  <v-col cols="9">Planos</v-col>
                  <v-col
                    cols="3"
                    class="d-flex justify-end"
                    v-if="showPlansActions"
                  >
                    <v-btn class="mr-1" small @click.native.stop="$refs.productSearch.show">
                      <v-icon small title="Adicionar">fas fa-plus</v-icon>
                    </v-btn>
                    <v-btn small @click.native.stop="$refs.plans.removeAll">
                      <v-icon small title="Remover">fas fa-trash</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                
                <coverage-product ref="plans" :coverage-id="id" />
              
              </v-expansion-panel-content>
            </v-expansion-panel>

            <product-search ref="productSearch" :coverage-id="id" @selected="addProduct" />
          
          </v-expansion-panels>

          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <v-row  class="mr-2">
                  <v-col cols="9">Informações do Registro</v-col>
                </v-row>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row v-if="coverageRevision">
                  <v-col cols="6">
                    <strong>Usuário de criação:</strong> {{ coverageRevision.write_uid }}
                  </v-col>
                  <v-col cols="6">
                    <strong>Usuário da última alteração:</strong> {{ coverageRevision.write_uid }}
                  </v-col>
                  <v-col cols="6">
                    <strong>Data de criação:</strong> {{ $util.formatDateToBR(coverageRevision.create_date )}}
                  </v-col>
                  <v-col cols="6">
                    <strong>Data da última alteração:</strong> {{ $util.formatDateToBR(coverageRevision.write_date )}}
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <product-search ref="productSearch" :coverage-id="id" @selected="addProduct" />
          
          </v-expansion-panels>
        </v-row>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import CoverageProduct from "@/view/coverage/coverage_products";
import CoverageCarrier from "@/view/coverage/coverage_carriers";
import CoveragePlanService from "@/services/odoo/CoveragePlanService";
import CoverageCarrierService from "@/services/odoo/CoverageCarrierService";
import ProductSearch from "@/view/coverage/coverage_product_search";
import CarrierSearch from "@/view/coverage/coverage_carrier_search";

export default {
  components: { CoverageProduct, ProductSearch, CarrierSearch, CoverageCarrier },
  data() {
    return {
      id: this.$route.params.id,
      coverage: null,
      isLoading: false,
      coveragePlans: [],
      showPlansActions: false,
      showCarriersActions: false,
    };
  },
  async created() {
    this._coveragePlanService = new CoveragePlanService();
    this._coverageCarrierService = new CoverageCarrierService();
    this.CLEAR_COVERAGE_DESCRIPTIONS();
    this.fetchCoverage(this.id).then((data) => {
      this.coverage = data
    }).finally(() => {
      this.isLoading = false;
    });
    this.fetchCoverageRevision(this.id)
  },
  computed: {
    ...mapGetters("coverage", ["coverageProcessed", "getCoverage", "coverageRevision"]),
  },
  methods: {
    ...mapActions("coverage", ["deleteCoverage", "fetchCoverage", "fetchCoverageRevision"]),
    ...mapMutations(["toogleDialogLoading", 'showmsg']),
    ...mapMutations('coverage', ['CLEAR_COVERAGE_DESCRIPTIONS']),
    edit() {
      this.$router.push(`/coverage/${this.id}/edit`);
    },
    async remove() {
      this.toogleDialogLoading(true);
      await this.deleteCoverage(this.id);
      this.goBack();
      this.toogleDialogLoading(false);
    },
    togglePlansActions() {
      this.$refs.productSearch.resetData();
      this.showPlansActions = !this.showPlansActions;
    },
    toggleCarriersActions() {
      this.showCarriersActions = !this.showCarriersActions;
    },
    async addProduct(products) {
      this.toogleDialogLoading(true);
      const bodyFormData = new FormData();
      products.forEach((product) => bodyFormData.append('planIds', product.id))
      try {
        await this._coveragePlanService.save(this.id,  bodyFormData)
        this.showmsg({text: 'Planos associados com sucesso'});
        await this.$refs.plans.loadData();
      } catch (e) {
        console.log(e)
      }
      this.toogleDialogLoading(false);
    },
    async addAccount(carriers) {
      this.toogleDialogLoading(true);
      const bodyFormData = new FormData();
      carriers.forEach((carrier) => bodyFormData.append('carrierIds', carrier.id))
      try {
        await this._coverageCarrierService.save(this.id,  bodyFormData)
        this.showmsg({text: 'Operadoras associadas com sucesso'});
        await this.$refs.carriers.loadData();
      } catch (e) {
        console.log(e)
      }
      this.toogleDialogLoading(false);
    },    
    goBack() {
      this.$router.push(`/coverage?token=`+localStorage.getItem('tiny_token'));
    },
  },
};
</script>
